import { AJSResponse } from '@qality/common-model/src/AP/AJS';
import { PromiseService } from '@qality/common-service';

type Uri = {
  url: string;
  type?: string;
};

type Args = {
  url?: string;
  type?: string;
  data?: unknown;
  contentType?: string | boolean;
  processData?: string | boolean;
  headers?: Record<string, unknown>;
};

export default {
  request: (uri: Uri | Args | string, args?: Args): Promise<AJSResponse> => {
    return PromiseService.retry(() => request(uri, args));
  },
  noRetry: (uri: Uri | string, args?: Args): Promise<AJSResponse> => {
    return request(uri, args);
  },
};

// eslint-disable-next-line complexity
function request(uri: Uri | Args | string, args?: Args): Promise<AJSResponse> {
  let AJS;
  if (window.frameElement !== null && window.frameElement !== undefined) {
    AJS = window.parent.AJS;
  } else {
    AJS = window.AJS;
  }
  const $ = AJS.$;

  let normalizedArguments = args;

  // normalize method arguments
  if (typeof uri === 'object') {
    normalizedArguments = uri;
  } else if (!args) {
    normalizedArguments = { url: uri };
  } else {
    normalizedArguments.url = uri;
  }
  // add the context path to the request url
  const contextPath = AJS.contextPath();
  const url = contextPath + normalizedArguments.url;

  const settings = {
    url: url,
    type: normalizedArguments.type || 'GET',
    data: normalizedArguments.data,
    dataType: 'text', // prevent jquery from parsing the response body
    contentType: normalizedArguments.contentType,
    cache: false,
    processData: normalizedArguments.processData,
    headers: {
      // */* will undo the effect on the accept header of having set dataType to 'text'
      Accept: '*/*',
      ...normalizedArguments.headers,
    },
  };

  return new Promise(function (resolve, reject) {
    // eslint-disable-line promise/avoid-new
    $.ajax(settings)
      .done(function (body) {
        resolve({ body: body });
      })
      .fail(function (xhr) {
        const error = {
          xhr: xhr,
          err: xhr.responseText,
        };
        reject(error);
      });
  });
}
